export const noteColors = [
  {
    id: 1,
    color: 'bg-white'
  },
  {
    id: 2,
    color: 'bg-orange-50'
  },
  {
    id: 3,
    color: 'bg-emerald-50'
  },
  {
    id: 4,
    color: 'bg-purple-50'
  }
];
